export default "__VITE_ASSET__DxCrM$HL__"